/**
 * Environment detection utilities using Vite's compile-time import.meta.env.
 *
 * These functions provide type-safe access to the build-time environment mode.
 * No runtime environment variable access occurs.
 */

/**
 * Checks if the application is running in development mode.
 *
 * @returns true when MODE is 'development', false otherwise
 */
export function isDevelopment(): boolean {
  return import.meta.env.MODE === 'development';
}

/**
 * Checks if the application is running in production mode.
 *
 * @returns true when MODE is 'production', false otherwise
 */
export function isProduction(): boolean {
  return import.meta.env.MODE === 'production';
}
